// @ts-nocheck
import * as AV from "../AVCore/AVCore";

export const getSeriesItem = async (event, userId) => {
  try {
    let repeatedEvents: any = [];

    let response: any = await AV.AVEntity.get(
      {
        id: event.id,
        pk: event.pk,
        region: event.region,
        type: event.type,
      },
      event._etag,
    );

    if (response?.seriesEvents?.length > 0) {
      const targetId = userId;
      const seriesParticipants = response?.participants;

      const seriesLocation = response.location;
      const seriesUrl = response.locURL;

      response?.seriesEvents.map((series: any) => {
        let participants = series?.participants;
        const result = participants?.filter((p) => p.id === targetId);
        let status = result && result.length > 0 ? result[0]?.status : null;

        const seriesResult = seriesParticipants?.filter(
          (p) => p.id === targetId,
        );
        if (status === null && seriesResult && seriesResult.length > 0) {
          status = seriesResult[0]?.status;
        }

        if (series?.status === "Canceled") status = series?.status;
        if (response?.status === "Canceled") status = response?.status;

        const eventLocation = series.location;
        const eventUrl = series.locURL;

        const loc =
          eventLocation || eventUrl || seriesLocation || seriesUrl || null;

        repeatedEvents.push({
          ...series,
          id: event.id,
          seriesId: series.id,
          title: response.name,
          url: eventUrl || seriesUrl,
          status: status || "RSVP",
          location: loc,
          eventType: response.eventType,
          linkType: event.linkType,
          parentId: response?.id,
          profile: response?.profile,
          type: response?.type,
          region: event?.region,
          pk: event?.pk,
          type: response?.type,
        });
      });
    }
    return repeatedEvents;
  } catch (e) {
    console.error("Error in getSeriesItem: ", e);
  }
};

export const getAllNonRepeatingEvents = async (event) => {
  try {
    let nonRepeatedEvents: any = [];
    let response: any = await AV.AVEntity.get(
      {
        id: event.id,
        pk: event.pk,
        region: event.region,
        type: event.type,
      },
      event._etag,
    );
    if (response) {
      nonRepeatedEvents.push({
        ...response,
        profile: response?.profile,
      });
    }

    return nonRepeatedEvents;
  } catch (e) {
    console.error("Error in getAllNonRepeatingEvents: ", e);
  }
};

export const getEvent = async (event) => {
  try {
    let response = await AV.AVEntity.get(
      {
        id: event?.parentId ?? event.id,
        pk: event?.pk,
        region: event?.region,
        type: event?.type,
      },
      event._etag,
    );
    return response;
  } catch (e) {
    console.error("Error in getEvent: ", e);
    return undefined;
  }
};
